import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
/**
 * Global error boundary — catches unhandled React render errors.
 * Logs to console.error (preserved in prod builds) and shows a fallback UI.
 */
export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, errorInfo) {
        console.error('[ErrorBoundary] Uncaught render error:', error, errorInfo.componentStack);
    }
    render() {
        if (this.state.hasError) {
            return (_jsxs("div", { style: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '100vh',
                    padding: '2rem',
                    fontFamily: 'system-ui, sans-serif',
                    background: '#0f172a',
                    color: '#e2e8f0',
                }, children: [_jsx("h1", { style: { fontSize: '1.5rem', marginBottom: '0.5rem' }, children: "Something went wrong" }), _jsx("p", { style: { color: '#94a3b8', marginBottom: '1.5rem', textAlign: 'center', maxWidth: '400px' }, children: "An unexpected error occurred. Please refresh the page or contact support if the issue persists." }), _jsx("button", { onClick: () => {
                            this.setState({ hasError: false, error: null });
                            window.location.href = '/';
                        }, style: {
                            padding: '0.5rem 1.5rem',
                            background: '#2563eb',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '0.5rem',
                            cursor: 'pointer',
                            fontSize: '0.875rem',
                            fontWeight: 600,
                        }, children: "Go to Home" }), process.env.NODE_ENV !== 'production' && this.state.error && (_jsxs("pre", { style: {
                            marginTop: '2rem',
                            padding: '1rem',
                            background: '#1e293b',
                            borderRadius: '0.5rem',
                            fontSize: '0.75rem',
                            maxWidth: '600px',
                            overflow: 'auto',
                            color: '#f87171',
                        }, children: [this.state.error.message, '\n', this.state.error.stack] }))] }));
        }
        return this.props.children;
    }
}
